import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Homepage from "./pages/homepage";
import ForParents from "./pages/for-parents";
import Programs from "./pages/programs";
import ProvisionalBanner from "./components/ProvisionalBanner";

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Don't scroll to top if there's a hash (like #consultation)
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ProvisionalBanner />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/parents" element={<ForParents />} />
        <Route path="/programs" element={<Programs />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;